module.exports = __webpack_public_path__ + "static/media/fishes-on-wall-1.e0d85b70.webp";